import { useEffect } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    q: "What drone survey services does Snesar provide?",
    a: "We provide drone land survey, LiDAR survey, photogrammetry and 3D mapping, construction progress monitoring, powerline and thermal inspection, aerial photography and videography, and 360° virtual tours across India.",
  },
  {
    q: "Are your drone operations DGCA compliant?",
    a: "Yes. We follow DGCA-aware, safety-first field protocols with documented workflows, and use RTK-enabled enterprise drones for survey-grade accuracy.",
  },
  {
    q: "What accuracy can I expect from a drone survey?",
    a: "With RTK/GCP-based workflows we deliver survey-grade accuracy suitable for design, BIM and engineering, typically down to a few centimetres depending on site conditions.",
  },
  {
    q: "Which deliverable formats do you provide?",
    a: "Orthomosaics, DEM, DSM, contours, point clouds (LAS/LAZ), CAD files, KML, GeoTIFF, 3D models, volume reports and detailed progress reports.",
  },
  {
    q: "Which cities and regions do you serve?",
    a: "We are based in Navi Mumbai and serve projects across Maharashtra and pan-India, including Mumbai, Pune, Thane and other major cities.",
  },
  {
    q: "How quickly can you mobilise for a project?",
    a: "We offer fast turnaround with a dedicated project team. Share your requirement and we typically respond with a proposal within 24 hours.",
  },
];

export const Faq = () => {
  useEffect(() => {
    const ld = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    let s = document.getElementById("faq-jsonld");
    if (!s) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "faq-jsonld";
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(ld);
    return () => {
      const el = document.getElementById("faq-jsonld");
      if (el) el.remove();
    };
  }, []);

  return (
    <section id="faq" className="py-24 bg-[#f8f9fa] border-t border-gray-200">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-widest text-[#8b8f99]">FAQ</span>
          <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-black text-[#10193f]">
            Frequently asked questions
          </h2>
        </div>
        <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-heading font-bold text-[#10193f] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#52525b] text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
